import React from 'react';
import BlogPostContainer from '../../Componant/Blog/BlogPost';

const BlogPost = () => {
  return (
    <div className='page-body'>
      <BlogPostContainer />
    </div>
  );
};

export default BlogPost;
